import type { ThemeOptions } from '@mui/material';

export const inputOutlinedComponent = {
  styleOverrides: {
    notchedOutline: {
      borderColor: '#9B9DB0',
    },
  },
} as const satisfies NonNullable<ThemeOptions['components']>['MuiOutlinedInput'];
